// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13.3135L22 13.3135V22ZM22 10.4854L10.4854 22H3.41406L22 3.41406V10.4854ZM2 20.5859L2 13.5146L13.5146 2L20.5859 2L2 20.5859ZM2 10.6865L2 2L10.6865 2L2 10.6865Z"}}]};

const PlaceholderFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'placeholder-filled',
    ref,
    icon: element,
  },
));

PlaceholderFilledIcon.displayName = 'PlaceholderFilledIcon';

export default PlaceholderFilledIcon;
